import { render, staticRenderFns } from "./AddAccommodatie.vue?vue&type=template&id=4c659356&"
import script from "./AddAccommodatie.vue?vue&type=script&lang=js&"
export * from "./AddAccommodatie.vue?vue&type=script&lang=js&"
import style0 from "./AddAccommodatie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports